var _rect, _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBrushPink(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 35,
    viewBox: "0 0 35 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 35,
    height: 35,
    rx: 10,
    fill: "#FB4764"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31.8062 5.74832C29.8958 10.5171 25.5354 16.7442 21.3792 20.8129C20.7812 17.0504 17.7771 14.1046 13.9854 13.5796C18.0687 9.40874 24.3396 4.98999 29.1229 3.06499C29.9687 2.74416 30.8146 2.99207 31.3396 3.51707C31.8937 4.07124 32.1562 4.90249 31.8062 5.74832Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M21.3785 20.8115C20.6493 21.526 19.9201 22.1823 19.2201 22.7365L16.3472 25.0406C15.9826 25.3031 15.6181 25.5219 15.2097 25.6969C15.2097 25.4198 15.1806 25.1427 15.1514 24.851C14.991 23.6406 14.4368 22.4885 13.4597 21.5115C12.4535 20.5198 11.2576 19.951 10.0181 19.7906C9.7264 19.7615 9.42015 19.7469 9.14307 19.7615C9.30348 19.3094 9.5514 18.8865 9.85765 18.5365L12.1326 15.6635C12.6722 14.9781 13.2993 14.2781 13.9847 13.5781C17.7764 14.1031 20.7806 17.049 21.3785 20.8115Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.2104 25.699C15.2104 27.3031 14.5979 28.8344 13.4312 29.9864C12.5416 30.8906 11.3458 31.5031 9.88748 31.6781L6.31457 32.0719C4.3604 32.2906 2.68332 30.6135 2.90207 28.6448L3.29582 25.0573C3.64582 21.8635 6.31457 19.8219 9.14373 19.7635C9.42082 19.749 9.72707 19.7635 10.0187 19.7927C11.2583 19.9531 12.4541 20.5219 13.4604 21.5135C14.4375 22.4906 14.9916 23.6427 15.1521 24.8531C15.1812 25.1448 15.2104 25.4219 15.2104 25.699Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBrushPink);
export default __webpack_public_path__ + "static/media/brush-pink.e47f53c92975d0dd514e1dd6b605c945.svg";
export { ForwardRef as ReactComponent };